import React from 'react';
import { Trans } from 'react-i18next';
import { Spinner } from '@vp/swan';
import { currentCulture } from 'src/utils/cultureUtil';
import { text } from 'src/utils/localizationUtil';

export interface Price {
  listPrice: number;
  discountedPrice: number;
  currency: string;
}

export type PriceDisplayProps = {
  price: Price;
  priceIsLoaded: boolean;
};

function formatIndividualPrice(price: number, currency: string) {
  return new Intl.NumberFormat(currentCulture, {
    currency,
    currencyDisplay: 'narrowSymbol',
    style: 'currency',
  }).format(price);
}

export function formatPrice({ discountedPrice, currency }: Price) {
  return formatIndividualPrice(discountedPrice, currency);
}

// This avoids uses children because that breaks the Trans component
export const PriceDisplay = ({ price, priceIsLoaded }: PriceDisplayProps) =>
  priceIsLoaded ? <ActualPrice>{price}</ActualPrice> : <Spinner accessibleText={text('loading')} />;

const ActualPrice = ({ children }: { children?: Price }) =>
  children ? (
    <span
      style={{
        width: 'max-content',
        textAlign: 'center',
        display: 'inline-block',
      }}
    >
      {formatIndividualPrice(children.discountedPrice, children.currency)}
    </span>
  ) : (
    <Trans i18nKey="free" />
  );
